import React, { memo } from "react";
import { NodeProps } from "reactflow";
import { NodeData, NodeType } from "../../../models/nodeType";
import { useForm } from "react-hook-form";
import { FlowNodeWithChildren } from "./FlowNode";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import FormInput from "../../../ui/form/FormInput";
import { Stack, Text } from "@chakra-ui/react";

interface PlayVideoNodeData extends NodeData {
  videoUrl: string;
}

const PlayVideoNode: React.FC<NodeProps<NodeType<PlayVideoNodeData>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const videoUrl = nodeData?.videoUrl ?? "";

  const { register, handleSubmit } = useForm<PlayVideoNodeData>({
    defaultValues: {
      videoUrl,
    },
    mode: "onChange",
  });

  const { updateNodeData } = useUpdateNodeData<PlayVideoNodeData>(nodeId);

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(updateNodeData)} onBlur={handleSubmit(updateNodeData)}>
        <Stack>
          <FormInput color={color} {...register("videoUrl")}>
            <Text color={color} casing={"uppercase"}>
              Video URL
            </Text>
          </FormInput>
        </Stack>
      </form>
    </FlowNodeWithChildren>
  );
};

export default memo(PlayVideoNode);
